var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2461_18179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0625 1.28369V24.7646H5.78419L9.25197 30.783L12.7198 24.7646H31.9376V1.28369H-0.0625ZM30.0611 22.8845H11.6363L9.25197 27.0224L6.86745 22.8845H1.81397V3.16383H30.0611V22.8845Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56836 8.1394H25.3323V10.0195H6.56836V8.1394Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56836 12.1687H25.3323V14.0491H6.56836V12.1687Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56836 16.1985H25.3323V18.0786H6.56836V16.1985Z",
    fill: "#858585"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2461_18179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentOrder);
export default __webpack_public_path__ + "static/media/commentOrder.4937bcd0d7144cf010abc0b2a982debd.svg";
export { ForwardRef as ReactComponent };